// removed by extract-text-webpack-plugin
module.exports = {"loaderText":"loaderText__zWl3d","mdc-dialog--open":"mdc-dialog--open__tYYNH","mdc-dialog__backdrop":"mdc-dialog__backdrop__3Ppnd"};


//////////////////
// WEBPACK FOOTER
// ./components/loader/loader.css
// module id = FgT3
// module chunks = 307 316 320 321 325 326 328 339 355